module.exports = __webpack_public_path__ + "img/HHaplakat2023.434b4938.jpg";